import { Col, Row, Button, Form, Input, message } from "antd";
import { useState, useEffect } from "react";
import {BsFacebook,BsInstagram, BsYoutube,BsGoogle  } from 'react-icons/bs'
import {FiSend} from 'react-icons/fi'
import {MdPhoneInTalk} from 'react-icons/md'
import service from "../service";
import {
  SendOutlined,
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  GoogleOutlined,
} from "@ant-design/icons";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import logo from '../../assets/opengovlogo.svg'
const { TextArea } = Input;
function Footer() {
  const [form] = Form.useForm();

  useEffect(() => {}, []);

  const onFinish = (data) => {
    service
      .saveForum(data)
      .then((res) => {
        if (res.message === "success") {
          message.success("Таны хүсэлтийг амжилттай хүлээн авлаа.");
        }
      })
      .catch((err) => {
        message.err("Амжилтгүй");
      });
  };

  return (
    // <Fade delay={100}>
      <div className="footer">
        <div className="footer-left">
          <div className="footer-logo"><img
                src={logo}
                height={25}
                className="App-logo"
                alt="logo"
                />
          </div>
          <div className="footer-left-text"  >
            <div style={{display: "flex"}}><div><FiSend style={{color: "#d2d2d2", marginRight: "1rem", fontSize: "1.2rem"}}/></div><div style={{color: "#0e0826", fontSize: 15}}>АЮУД тауэр 1003 тоот Энхтайваны өргөн чөлөө 17, СБД, 1-р хороо, Улаанбаатар, 14240, Монгол Улс.</div></div>
            <div style={{display: "flex"}}><div><MdPhoneInTalk style={{color: "#d2d2d2", marginRight: "1rem", fontSize: "1.2rem"}}/></div><div style={{color: "#0e0826", fontSize: 15}}>75077171</div></div> 
          </div>
          <div className="footer-left-socials">
              <a href="https://www.facebook.com/profile.php?id=100084013540849"><BsFacebook  className="svgs"/></a>
              <BsInstagram className="svgs" />
              <BsYoutube  className="svgs"/>
              <BsGoogle className="svgs"/>
              </div>
      </div>
      <div className="footer-right">
      <div className="footer-right-text">
              Санал хүсэлт
            </div>
      <Form className="footer-form" form={form} name="register" onFinish={onFinish}>
      <div className="footer-form-left"> <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "Нэрийг заавал оруулна уу.",
              },
            ]}
          >
            <Input className="footer-form-input" placeholder="Нэр" style={{ borderRadius: "20px" }} />
          </Form.Item>
          <Form.Item
            name="phone_num"
            rules={[
              {
                required: true,
                message: "Утасны дугаарыг заавал оруулна уу.",
              },
            ]}
          >
            <Input
            className="footer-form-input"
              placeholder="Утас"
              style={{ borderRadius: "20px" }}
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                required: true,
                message: "И-мейл хаяг заавал оруулна уу.",
              },
            ]}
          >
            <Input
            className="footer-form-input"
              type="text"
              placeholder="И-мэйл"
              style={{ borderRadius: "20px", marginBottom: "10px" }}
            />
          </Form.Item>
          <div><button
        htmlType="submit"
        shape="round"
        type="primary"
        icon={<SendOutlined />}
        size="middle"
        className="app__header-login-button"
        style={{marginBottom: "3rem"}}
      >
        Илгээх
      </button></div></div>
          <div className="footer-form-right"><Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: "Агуулга заавал оруулна уу.",
              },
            ]}
          >
            <TextArea
              rows={10}
              placeholder="Агуулга"
            
              minLength={6}
              style={{ borderRadius: "20px", height: "100%" }}
            />
          </Form.Item></div>
      
    </Form>
      </div>
            
       
            
            
      </div>
    // </Fade>
  );
}

export default Footer;
